import React, { useState, useEffect } from 'react';
import { CheckTemplateShift ,getTemplateShifts } from '../api/template_shift'
import { GetRestaurants } from '../api/restaurant'

const CheckDep = ({token}) => {
    const [file, setFile] = useState('')
    const [statusFile, setStatusFile] = useState([])
    const [restaurants, setRestaurants] = useState([])

    const [selectedRestaurant, setSelectedRestaurant] = useState(0)
    const [selectedStartDate, setSelectedStartDate] = useState()
    const [selectedEndDate, setSelectedEndDate] = useState()
    const [loadedTemplateShifts, setLoadedTemplateShifts] = useState([])
    const [haveTemplateShifts, setHaveTemplateShifts] = useState(false)
    const [message, setMessage] = useState()
    const [haveFile, setHaveFile] = useState(false)

    

    const fetchAllRestaurants = async () => {
        try {
            const data = await GetRestaurants(token, 1, 50)
            setRestaurants(data.data)
        }
        catch (error){
        }
    }
    
    useEffect(() => {
            
            fetchAllRestaurants();
        }, [token]);

    async function addFile(event) {
        setFile(event.target.files[0])
        setHaveFile(true)
    }

    async function sendFile(event) {
        const data = await CheckTemplateShift(token, file)
        console.log(data['success'])
        setStatusFile(data['errors'])
        setLoadedTemplateShifts(data['success'])
    }


    async function loadTemplateShifts(event){
        const data = await getTemplateShifts(token, selectedRestaurant, selectedStartDate, selectedEndDate)
        setLoadedTemplateShifts(data)
        if (data.length > 0){
            setHaveTemplateShifts(true)
        }
        else {
            setHaveTemplateShifts(false)
        }
    }

    function renderTempaleShift(ts){
        if (ts){
            return `${ts.date}. ${ts.start} - ${ts.end}. ${ts.station_name}`
        }
    }

    function renderShift(s){
        if (s) {
            return <div className='text-center' style={{background: "green", fontWeight: "bold"}}>Есть</div>}
        if (!s) return <div className='text-center' style={{background: "red", fontWeight: "bold"}}>Нет</div>
    }


    return (
        <div className="container">
            <div className="row">
                <div className="col-md-12">
                    <h1 className='text-center' style={{marginTop: "5%"}}>Проверка шаблона смен</h1>
                </div>
                <div className="col-md-6">
                    <div className="form text-center" style={{marginTop: "5%"}}>
                        <input className="form-control" type="file" id="formFile" onChange={addFile}></input>
                        { haveFile &&  (<button className="btn" onClick={sendFile} style={{marginTop: "5%"}}>Отправить</button>)}
                    </div>
                    
                </div>
                <div className="col-md-6">
                    <div className="info" style={{marginTop: "5%"}}>
                        <table className='table table-bordered'>
                            <thead><tr><th className='text-center'>Строки с проблемами</th></tr></thead>
                            <tbody>
                                {statusFile && (
                                statusFile.map( (error, index) => (
                                    <tr key={index}><td className='text-center'>{error}</td></tr>
                                ))
                            )}
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="col-md-12" style={{marginTop: "5%"}}>
                    <table className='table table-bordered'>
                        <thead>
                            <tr>
                                <th className='text-center'>Правильные смены</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loadedTemplateShifts.map( row => (
                                <tr>
                                    {console.log(row, 999)}
                                    <td className='text-center'>{renderTempaleShift(row)}</td>
                                </tr>
                            ))}
                        </tbody>

                    </table>
                </div>
            </div>
            <div className="modal fade" id="staticBackdrop" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header justify-content-center">
                            <h5 className="modal-title text-center" id="staticBackdropLabel">Информация</h5>
                        </div>
                        <div className="modal-body">
                            {message}
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}


export default CheckDep




